export const loadConvivaScripts = () => {
  const convivaSdk = document.getElementById('convivaSdkScript');
  if (!convivaSdk) {
    const convivaSdkScript = document.createElement('script');
    convivaSdkScript.setAttribute(
      'src',
      `/webapp-assets/scripts/conviva-core-sdk.js?ver=${process.env.APP_VERSION}`
    );
    convivaSdkScript.setAttribute('defer', 'defer');
    convivaSdkScript.setAttribute('id', 'convivaSdkScript');
    document.head.appendChild(convivaSdkScript);
  }

  const convivaVjsModule = document.getElementById('convivaVjsModuleScript');
  if (!convivaVjsModule) {
    const convivaVjsModuleScript = document.createElement('script');
    convivaVjsModuleScript.setAttribute(
      'src',
      `/webapp-assets/scripts/conviva-videojs-module.js?ver=${process.env.APP_VERSION}`
    );
    convivaVjsModuleScript.setAttribute('defer', 'defer');
    convivaVjsModuleScript.setAttribute('id', 'convivaVjsModuleScript');
    document.head.appendChild(convivaVjsModuleScript);
  }
};

export const loadConvivaAdsScripts = () => {
  const convivaImaModule = document.getElementById('convivaImaModuleScript');
  if (!convivaImaModule) {
    const convivaImaModuleScript = document.createElement('script');
    convivaImaModuleScript.setAttribute(
      'src',
      `/webapp-assets/scripts/conviva-core-sdk.js?ver=${process.env.APP_VERSION}`
    );
    convivaImaModuleScript.setAttribute('defer', 'defer');
    convivaImaModuleScript.setAttribute('id', 'convivaImaModuleScript');
    document.head.appendChild(convivaImaModuleScript);
  }
};
